import { render, staticRenderFns } from "./ProductList2.vue?vue&type=template&id=fb4f41cc"
import script from "./ProductList2.vue?vue&type=script&lang=js"
export * from "./ProductList2.vue?vue&type=script&lang=js"
import style0 from "./ProductList2.vue?vue&type=style&index=0&id=fb4f41cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports